import { render, staticRenderFns } from "./AddBoostForm.vue?vue&type=template&id=a138fb18&scoped=true&"
import script from "./AddBoostForm.vue?vue&type=script&lang=js&"
export * from "./AddBoostForm.vue?vue&type=script&lang=js&"
import style0 from "./AddBoostForm.vue?vue&type=style&index=0&id=a138fb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a138fb18",
  null
  
)

export default component.exports